import { render } from "./archivedContents.vue?vue&type=template&id=43abb135&scoped=true"
import script from "./archivedContents.vue?vue&type=script&lang=js"
export * from "./archivedContents.vue?vue&type=script&lang=js"

import "./archivedContents.vue?vue&type=style&index=0&id=43abb135&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43abb135"]])

export default __exports__